import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import type { IntentValuesType } from 'Deer/intent/types/IntentCommonTypes';

export type RewardsIntentType = {
  id: string;
  label: string;
  onClick: () => void;
  visible: () => boolean;
  category: string;
  value: {
    myData?: IntentValuesType;
    team?: {
      directReports: IntentValuesType;
      allReports: IntentValuesType;
    };
    company?: IntentValuesType;
  };
  hasMetaFilters?: boolean;
};

const initialState: {
  selectedIntent: null | RewardsIntentType;
} = {
  selectedIntent: null,
};

export const rewardsIntentSlice = createSlice({
  name: 'rewardsIntent',
  initialState,
  reducers: {
    setSelectedRewardsIntent: (state, action: PayloadAction<RewardsIntentType>) => {
      state.selectedIntent = action.payload;
    },
  },
});

export const { setSelectedRewardsIntent } = rewardsIntentSlice.actions;

export default rewardsIntentSlice.reducer;

export const useSelectRewardsSelectedIntent = () =>
  useSelector((state: { rewardsIntent: typeof initialState }) => state.rewardsIntent.selectedIntent);
